import { CallStatus } from '../../types';

export function isLiveCallTrackingStatus(status: CallStatus): boolean {
  return (
    status === 'ringing' || status === 'connecting' || status === 'active' || status === 'holding'
  );
}
